import axios from "axios";

// ─── Constants ────────────────────────────────────────────────────────────────
const BPS_API_KEY  = process.env.REACT_APP_BPS_API_KEY || "2a5fc573c8b3c000270a925dd7d8f334";
const BPS_BASE_URL = "https://webapi.bps.go.id/v1/api";
const BPS_DOMAIN   = "3527"; // Kode domain Kab. Sampang

/**
 * BPS API per_page adalah FIXED = 10, tidak bisa diubah dari client.
 * Export agar komponen bisa import dan pakai sebagai acuan pagination.
 */
export const BPS_PER_PAGE = 10;

// ─── Axios Instance ───────────────────────────────────────────────────────────
const bpsApi = axios.create({ baseURL: BPS_BASE_URL });

// ─── Helpers ──────────────────────────────────────────────────────────────────
const withKey = (path) => `${path}/key/${BPS_API_KEY}/`;

const normalizeDataset = (item) => ({
    name:              String(item.table_id ?? "bps"),
    title:             item.title?.trim()     ?? "-",
    author:            "BPS",
    metadata_modified: item.updt_date         ?? new Date().toISOString(),
    subject:           item.subj              ?? "",
    size:              item.size              ?? "-",
    excel_url:         item.excel             ?? "",
    source:            "BPS",
    raw_data:          item,
});

// ─── Service Functions ────────────────────────────────────────────────────────

/**
 * Ambil metadata organisasi BPS.
 * @returns {Array}
 */
export const getBpsOrganizations = async () => {
    try {
        const res = await bpsApi.get(
            withKey(`/model/statictable/lang/ind/domain/${BPS_DOMAIN}`)
        );
        return res.data?.data?.[1] ?? [];
    } catch (error) {
        console.error("getBpsOrganizations:", error.message);
        return [];
    }
};

/**
 * Ambil total jumlah dataset BPS Kab. Sampang.
 * @returns {number}
 */
export const getBpsDatasetCount = async () => {
    try {
        const res = await bpsApi.get(
            withKey(`/list/model/statictable/lang/ind/domain/${BPS_DOMAIN}/page/1`)
        );
        return res.data?.data?.[0]?.total ?? 0;
    } catch (error) {
        console.error("getBpsDatasetCount:", error.message);
        return 0;
    }
};

/**
 * Ambil daftar dataset BPS dengan pagination.
 * BPS API per_page FIXED = 10 — parameter rows diabaikan oleh API.
 *
 * @param {number} page - Nomor halaman (default: 1)
 * @returns {{ total: number, perPage: number, datasets: Array }}
 */
export const getBpsDatasets = async (page = 1) => {
    try {
        const res = await bpsApi.get(
            withKey(`/list/model/statictable/lang/ind/domain/${BPS_DOMAIN}/page/${page}`)
        );
        const data = res.data?.data;
        if (!data) return { total: 0, perPage: BPS_PER_PAGE, datasets: [] };

        return {
            total:    data[0]?.total ?? 0,  // ✅ field "total", bukan "records"
            perPage:  BPS_PER_PAGE,
            datasets: (data[1] ?? []).map(normalizeDataset),
        };
    } catch (error) {
        console.error("getBpsDatasets:", error.message);
        return { total: 0, perPage: BPS_PER_PAGE, datasets: [] };
    }
};

/**
 * Ambil detail satu dataset BPS berdasarkan tableId.
 * Digunakan di halaman DetailDataBPS.
 *
 * @param {string|number} tableId - ID tabel BPS
 * @returns {Object|null}
 */
export const getBpsDatasetDetail = async (tableId) => {
    try {
        const res = await bpsApi.get(
            withKey(`/view/model/statictable/lang/ind/id/${tableId}`)
        );
        const item = res.data?.data?.[1];
        if (!item) return null;
        return normalizeDataset(item);
    } catch (error) {
        console.error("getBpsDatasetDetail:", error.message);
        return null;
    }
};